import { ADD_MSG, CLEAR_MSGS, REMOVE_MSG } from '../constants';

const initialState = [];

export default function reducer(state = initialState, action) {
    switch(action.type) {
        case ADD_MSG: 
            return state.concat(action.msg);
        case CLEAR_MSGS: 
            return [];
        case REMOVE_MSG:
            return state.filter(msg => msg.id !== action.id)
        default:
            return state;
    }
}